<template lang="pug">
  .tilt-card
    .shadow
    //.notify(v-if="checkInStatus===-1")
      img(src="~assets/notify.png")
    // .tilt(ref="tilt" @click="onQueue")
    .tilt(ref="tilt")
      .card(ref="card" :class="active? 'active':''" @mousedown="onmousedown" @mouseup="onmouseup")
        img(src="~assets/queue-card.jpg")
      .copy
        // .title 展项排号
        // .subtitle 特别展项需要排号才能体验哦
        .title 展项体验
        .subtitle 空间站新上线“我的足迹”及“惊喜盲盒”，点击下方“我的足迹”入口，一起探索吧！
        // .subtitle 温馨提示：
        // .subtitle 7月8日-7月30日为“身边的蚂蚁森林”体验展，预约还可体验“飞跃蚂蚁森林”等展项，人流较多，入场请遵从工作人员引导哦！
      // .btn 立即排号
</template>

<script>
import VanillaTilt from 'src/libs/vanilla-tilt'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'TiltCardCheckin',
  props: {
    img: {},
    copy: {},
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapState('app', ['user']),
  },
  mounted() {
    console.log('check!!!!!!!!!!!!!!!', this.user.checkin)
    //Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)
    VanillaTilt.init(this.$refs.tilt, {
      max: 10,
      speed: 400,
      //glare: true,
    })
  },
  methods: {
    ...mapActions('app', ['GetUser']),
    ...mapMutations('app', ['toggleQueuePanel', 'setPending']),
    onQueue() {
      this.setPending(true)
      this.GetUser(this.user.id).then((res) => {
        this.setPending(false)
        this.toggleQueuePanel(true)
      })
    },
    // onClick() {
    //   //this.active = true
    //   this.$emit('clicked')
    // },
    // _onGyroUpdate(evt) {
    //   console.log(evt)
    // },
    onmousedown() {
      this.active = true
    },
    onmouseup() {
      this.active = false
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.tilt-card
  width: 100%
  height: 100%
  position: relative
  .notify
    width: pxToRem(670*1.1)
    height: pxToRem(82*1.1)
    top: pxToRem(-120)
    left: 0
    position: absolute
    img
      margin-left: pxToRem(-50)
      width: 100%
      height: 100%
      object-fit: contain
  .tilt
    position: relative
    width: 100%
    height: 100%
    border-radius: pxToRem(16)
    transform-style: preserve-3d
    box-shadow: 0 pxToRem(20) pxToRem(60) pxToRem(-10) rgba(59, 74, 92, 0.7), 0 pxToRem(40) pxToRem(90) 0 rgba(22, 139, 255, 0.2), pxToRem(2) pxToRem(10) pxToRem(25) pxToRem(-10) rgba(22, 139, 255, 0.5)
    //-webkit-mask-image: -webkit-radial-gradient(white, black);

    .card
      width: 100%
      height: 100%
      overflow: hidden
      transform-origin: center
      transition: transform 0.1s $easeOutCubic
      border-radius: pxToRem(16)
      //box-shadow: 0 20px 70px -10px rgba(51, 51, 51, 0.7), 0 50px 100px 0 rgba(51, 51, 51, 0.2)
      -webkit-mask-image: -webkit-radial-gradient(white, black)
      img
        transition: transform 0.1s $easeOutCubic
        transform-origin: center
        position: relative
        left: -2.5%
        top: -2.5%
        width: 105%
        height: 105%
      &.active
        transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
        transform: scale(1.03)
        img
          transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
          transform: scale(0.955)

    .copy
      color: #fff
      position: absolute
      left: pxToRem(35)
      top: pxToRem(31)
      transform: translateZ(20px)
      .title
        font-size: pxToRem(42)
        line-height: pxToRem(50)
        color: white
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
      .subtitle
        color: white
        margin-top: pxToRem(10)
        font-size: pxToRem(30)
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
    .btn
      width: pxToRem(168)
      height: pxToRem(58)
      border-radius: pxToRem(29)
      background: white
      color: #1664FF
      font-size: pxToRem(30)
      line-height: pxToRem(58)
      text-align: center
      position: absolute
      left: pxToRem(35)
      bottom: pxToRem(40)
</style>
